export const PRODUCT_COLLECTION_LAYOUT = 'pj:productCollectionLayout';
export const FILTER_PORTAL_ID = 'sidebar-filter';
export const PRODUCT_COLLECTION_LAST_FILTERS =
  'pj:productCollectionLastFilters';
